import { render, staticRenderFns } from "./extResult.vue?vue&type=template&id=71a9a7fe&scoped=true&"
import script from "./extResult.vue?vue&type=script&lang=js&"
export * from "./extResult.vue?vue&type=script&lang=js&"
import style0 from "./extResult.vue?vue&type=style&index=0&id=71a9a7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9a7fe",
  null
  
)

export default component.exports